/* eslint-disable react-hooks/exhaustive-deps */
import { Settings, LogOut, UserRound } from 'lucide-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DropdownMenu } from './DropDownMenu';
import { MenuTrigger } from './MenuTrigger';
import useAuth from 'features/auth/hooks/useAuth';
import { RoutesPaths } from 'routes/RoutesPathsEnum';
import { MenuItem } from '../types/types';

export const ProfileDropdown: React.FC = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { t } = useTranslation();
	const { logout, getUser } = useAuth();
	const user = getUser();

	const handleLogout = () => {
		logout();
	};

	const menuItems: MenuItem[] = [
		{
			icon: <Settings className='h-4 w-4' />,
			label: t('profile.settings'),
			href: RoutesPaths.PROFILE_EDIT
		},
		{
			icon: <LogOut className='h-4 w-4' />,
			label: t('profile.logout'),
			onClick: handleLogout,
			className: 'text-red-600'
		}
	];

	return (
		<DropdownMenu isOpen={isOpen} setIsOpen={setIsOpen}>
			<MenuTrigger
				isOpen={isOpen}
				onClick={() => setIsOpen(!isOpen)}
				icon={<UserRound className='h-5 w-5 text-blue-600' />}
			/>

			{isOpen && (
				<div className='absolute right-0 mt-2 w-56 rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5'>
					<div className='border-b px-4 py-2'>
						<p className='text-sm font-medium text-gray-900'>
							{user?.firstName} {user?.lastName}
						</p>
					</div>

					<div className='py-1'>
						{menuItems.map((item, index) =>
							item.href ? (
								<a
									key={index}
									href={item.href}
									className={`flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-100 ${item.className || 'text-gray-700'}`}
								>
									{item.icon}
									{item.label}
								</a>
							) : (
								<button
									key={index}
									onClick={item.onClick}
									className={`flex w-full items-center gap-3 px-4 py-2 text-sm hover:bg-gray-100 ${item.className || 'text-gray-700'}`}
								>
									{item.icon}
									{item.label}
								</button>
							)
						)}
					</div>
				</div>
			)}
		</DropdownMenu>
	);
};
